import LoginSignupPage from 'pages/LoginSignup/LoginSignupPage/LoginSignupPage';
import { memo } from 'react';
import { useLocation } from 'react-router-dom';

import './homepage.scss';

import ScrollToTop from 'utils/ScrollToTop';
import { isMobile } from 'react-device-detect';
import { getAuthCookie } from 'helpers/auth';

const Homepage = () => {
  const location = useLocation();
  const isLoginPage = ['/login'].includes(location.pathname);
  const isSignupPage = ['/signup'].includes(location.pathname);
  const isHome = ['/'].includes(location.pathname)

  const token = JSON.parse(localStorage.getItem('user'))?.user?.token;
  const authCookie = getAuthCookie();
  const origin = window.location.origin

  if (isHome && !token && !authCookie && origin === 'https://go.heepsy.com') {
    window.location.href = 'https://www.heepsy.com';
  } else if (isHome && !token && !authCookie) {
    window.location.href = 'https://stagingstatics.web.app/';
  }

  return (
    <div className="signup signup-page">
      <ScrollToTop />
      {!isMobile && !isHome ? (
        <LoginSignupPage
          toggleVisibility={() => {}}
          isLoginPage={isLoginPage}
          isSignupPage={isSignupPage}
          toggleLogin={() => {}}
        />
      ) : null}
    </div>
  );
};

export default memo(Homepage);
